import React from 'react';

/**
 * HighlightedText
 * ---------------
 * Wraps each occurrence of a whitespace-separated token from ``query`` in the
 * given ``text`` with a soft yellow background. Case-insensitive match; tokens
 * shorter than 2 chars are ignored so single letters don't paint the whole
 * title.
 */
export const HighlightedText = ({ text, query, className = '' }) => {
  if (!text) return null;
  const tokens = (query || '')
    .split(/\s+/)
    .map((t) => t.trim())
    .filter((t) => t.length >= 2);
  if (tokens.length === 0) return <>{text}</>;
  const escaped = tokens.map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  const re = new RegExp(`(${escaped.join('|')})`, 'gi');
  const lowered = tokens.map((t) => t.toLowerCase());
  const parts = String(text).split(re);
  return (
    <span className={className}>
      {parts.map((part, i) =>
        lowered.includes(String(part).toLowerCase())
          ? <mark key={i} className="bg-yellow-100 text-inherit rounded px-0.5" data-testid="search-highlight">{part}</mark>
          : <React.Fragment key={i}>{part}</React.Fragment>
      )}
    </span>
  );
};

export default HighlightedText;
